import React from "react";
import AllAskTransaction from "../component/sections/finance/AllAskTransaction";
import AddAskTransaction from "../component/sections/finance/AddAskTransaction";
import InfoAskTransaction from "../component/sections/finance/InfoAskTransaction";
import AllWalletLogPosition from "../component/sections/finance/AllWalletLogPosition";
import AllScoreLogPosition from "../component/sections/finance/AllScoreLogPosition";
import AllTransactionScoreToWalletAdvertiser from "../component/sections/finance/AllTransactionScoreToWalletAdvertiser";
import AddTransactionScoreToWalletAdvertiser from "../component/sections/finance/AddTransactionScoreToWalletAdvertiser.jsx";

const sitesRoutes = [
  {
    path: "/finance/ask-transaction/all",
    render: () => <AllAskTransaction />,
    exact: true,
  },
  {
    path: "/finance/ask-transaction/add",
    render: () => <AddAskTransaction />,
    exact: true,
  },
  {
    path: "/finance/ask-transaction/info/:askTransactionID",
    render: () => <InfoAskTransaction />,
    exact: true,
  },
  {
    path: "/finance/all-transaction-score-to-wallet-advertiser",
    render: () => <AllTransactionScoreToWalletAdvertiser />,
    exact: true,
  },
  {
    path: "/finance/add-transaction-score-to-wallet-advertiser",
    render: () => <AddTransactionScoreToWalletAdvertiser />,
    exact: true,
  },
  {
    path: "/finance/all-wallet-log-position",
    render: () => <AllWalletLogPosition />,
    exact: true,
  },
  {
    path: "/finance/all-score-log-position",
    render: () => <AllScoreLogPosition />,
    exact: true,
  },
];

export default sitesRoutes;
